export default "__VITE_ASSET__Zm4o3EDW__"